import { motion } from "framer-motion";
import { Download } from "lucide-react";
import { AWARDS, ACTING_RESUME_URL } from "@/lib/data";

export default function Acting() {
    return (
        <section
            id="acting"
            data-testid="acting-section"
            className="bg-[#F7F5F0] py-24 md:py-32 border-t border-[#D1CFC9]"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-6 md:gap-12 mb-16 md:mb-24">
                    <div className="col-span-12 md:col-span-6">
                        <p className="eyebrow">§ 03</p>
                        <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl mt-3 leading-[0.92] text-[#1A1A1A]">
                            Selected <span className="italic">Acting</span>
                            <br />
                            Credits
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-6 md:pl-12 flex flex-col justify-end gap-6">
                        <p className="text-base md:text-lg text-[#4A4A4A] font-light leading-relaxed max-w-md">
                            Three decades on stages from the Royal George to
                            Asolo Rep — leads, featured roles, and
                            award-winning performances.
                        </p>
                        <a
                            href={ACTING_RESUME_URL}
                            download="Vickie-Daignault-Acting-Resume.pdf"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="download-acting-resume"
                            className="btn-outline w-fit"
                        >
                            <Download size={14} />
                            Full Credits & Résumé
                        </a>
                    </div>
                </div>

                {/* Awards & Honors — featured editorial layout */}
                <div className="border-t border-[#1A1A1A] pt-10 md:pt-14">
                    <div className="flex items-baseline justify-between flex-wrap gap-4 mb-10 md:mb-14">
                        <p className="eyebrow">Awards & Honors</p>
                        <p className="font-serif-display italic text-base md:text-lg text-[#4A4A4A]">
                            A few highlights.
                        </p>
                    </div>

                    <div
                        data-testid="awards-list"
                        className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-10 md:gap-y-0"
                    >
                        {AWARDS.map((a, idx) => (
                            <motion.article
                                key={idx}
                                initial={{ opacity: 0, y: 18 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.3 }}
                                transition={{
                                    duration: 0.6,
                                    delay: idx * 0.1,
                                }}
                                data-testid={`award-${idx}`}
                                className={`md:px-8 ${
                                    idx > 0
                                        ? "md:border-l border-[#D1CFC9]"
                                        : ""
                                }`}
                            >
                                <div className="font-serif-display text-5xl md:text-6xl text-[#C67C4E] leading-none mb-4">
                                    {a.year}
                                </div>
                                <h3 className="font-serif-display text-xl md:text-2xl text-[#1A1A1A] leading-snug mb-3">
                                    {a.title}
                                </h3>
                                <p className="text-xs tracking-[0.18em] uppercase text-[#1A1A1A] mb-2">
                                    {a.org}
                                </p>
                                <p className="text-sm italic text-[#4A4A4A] leading-relaxed">
                                    {a.for}
                                </p>
                            </motion.article>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
